import * as api from '../api.service';
// this will return the encrypted data tobe sent to Portal2
const get = async () => api.fetchData<string>(`${process.env.REACT_APP_API_URL}/user/createPortalSSOToken`);

const SSORouterService = {
  get,
};

export default SSORouterService;
